import { Info } from '@clearkit/icons';
import classnames from 'classnames';
import { CKCopyWell, CKLayoutHorizontal } from 'clearkit';
import { ReactNode } from 'react';

type ConfigureIntegrationProps = {
  snippet: string;
  integrationText: ReactNode;
  copyText: ReactNode;
  textAreaHeight?: number;
  copyButtonText?: string;
};

const Integration = ({
  snippet,
  integrationText,
  copyText,
}: ConfigureIntegrationProps) => {
  const fontClasses = 'text-sm';

  return (
    <div className="space-y-4">
      <div className={fontClasses}>{integrationText}</div>

      <CKCopyWell isMultiline value={snippet} />
      <CKLayoutHorizontal
        className={classnames(fontClasses, 'text-gray-600')}
        gap="0.25rem"
        justifyContent="start"
      >
        <Info />
        <span>{copyText}</span>
      </CKLayoutHorizontal>
    </div>
  );
};

export default Integration;
